/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { getAllCustomerApi } from "@/api/customer/customer";
import CustomerMultiSelect from "./CustomerMultiSelect";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "@/hooks/useAuth";
import { printPdfFromUrl } from "@/lib/download";
import { printLoyaltyNativeCard } from "@/api/loyaltyNativePrinting";

const AddCustomer = ({
  isOpen,
  onClose,
  title = "Send Voucher via",
	options = [
		// "Whatsapp",
		// "SMS",
		"EMAIL",
		"Print",
	],
  value = [],
  onChange,
  onConfirm,
	onPrint,
//   customer,
  selectedVoucher,
  apiFunction,
  recallData,
	recallHistoryData,
	singleSelect = false,
}) => {
	const { user } = useAuth();
	const dispatch = useDispatch();
	const [selectedUser, setSelectedUser] = useState([]);
	const [loading, setLoading] = useState(false);
	const { search, getLoading, status, perPage, currentPage } = useSelector(
		(state) => state.loyalty.giftCard
	);

	const [customer, setCustomer] = useState([])
	useEffect(() => {
		if (!isOpen || customer.length > 0) return;
		getAllCustomerApi()
			.then(res => {
				if (res.status === 'success') {
					setCustomer(res.data.customers);
				}
			});
	}, [isOpen]);

	
	if (!isOpen) return null;

	const toggleOption = (option) => {
		let updated;
		if (value.includes(option)) {
			updated = value.filter((o) => o !== option);
		} else if (singleSelect) {
			updated = [option];
		} else {
			updated = [...value, option];
		}
		onChange(updated);
	};

	const getPdfUrl = () =>
		selectedVoucher?.pdf_url ||
		selectedVoucher?.gift_card?.pdf_url ||
		selectedVoucher?.voucher?.pdf_url ||
		selectedVoucher?.point_base_card?.pdf_url ||
		selectedVoucher?.gift_card_histories?.[0]?.pdf_url ||
		selectedVoucher?.voucher_histories?.[0]?.pdf_url ||
		selectedVoucher?.point_base_card_histories?.[0]?.pdf_url ||
		null;

	const handleConfirm = async () => {
		const selectedOption = value?.[0];
		const isGiftCard = selectedVoucher?.gift_card_id || selectedVoucher?.gift_card?.id;
		if (selectedOption === "Print" && !isGiftCard) {
			console.log("Selected option for printing:", selectedVoucher);

			if(selectedVoucher?.template_id && (selectedVoucher?.template_id == 8 || selectedVoucher?.template_id == 16)) {
				const customerId = selectedUser?.[0]?.id || null;
				const nativePrintPayload = {
					restaurant_id: Number(selectedVoucher?.restaurant_id || user?.restaurant_id),
					customer_id: customerId ? Number(customerId) : null,
					channels: ["print"],
					card_type: "point-base-card",
				};
				printLoyaltyNativeCard(selectedVoucher?.restaurant_id || user?.restaurant_id, selectedVoucher?.id, "point-base-card", nativePrintPayload);
				onChange([]);
				setSelectedUser([]);
				onClose();
				return;
			} 
			else {
				const pdfUrl = getPdfUrl();
				if (!pdfUrl) {
					toast.error("PDF URL not found for printing.");
					return;
				}

				try {
					const shouldClose = await onPrint?.(value, {
						selectedUser,
						selectedVoucher,
					});
					if (shouldClose !== false) {
						printPdfFromUrl(pdfUrl);
						onChange([]);
						setSelectedUser([]);
						onClose();
					}
				} catch (err) {
					toast.error(err?.message || "Failed to open PDF for printing.");
				}
			}
			return;
		}

		if (!apiFunction && onConfirm) {
			const shouldClose = await onConfirm(value, {
				selectedUser,
				selectedVoucher,
			});

			if (shouldClose !== false) {
				onChange([]);
				setSelectedUser([]);
				onClose();
			}
			return;
		}

		const payload = {
			restaurant_id: selectedVoucher?.restaurant_id,
			customer_id: selectedUser[0]?.id,
			gift_card_id: selectedVoucher?.gift_card_id,
			voucher_id: selectedVoucher?.voucher_id,
			point_base_card_id: selectedVoucher?.point_base_card_id,
			reward: selectedVoucher?.reward,
		};
			
		try {            
			setLoading(true);
			const res = await apiFunction(payload);
			if (res.status === "success") {
				toast.success("Added customer successfully");
				await onConfirm?.(value, {
					selectedUser,
					selectedVoucher,
				});
				if (recallData) {
					dispatch(recallData({restaurant_id: user?.restaurant_id}));
				}
				if (recallHistoryData) {
					dispatch(recallHistoryData({restaurant_id: user?.restaurant_id}));
				}
				onChange([])
				setSelectedUser([]);
				onClose();
			} else {
				toast.error(res.message || "Failed to add staff");
			}
		} catch (err) {
			toast.error(err?.message || "Failed to add voucher");
		} finally {
			setLoading(false);
		}
	};

	
	return (
		<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
			<div className="bg-gray-900 p-6 rounded-lg w-96 text-white shadow-xl">
				{/* Title */}
				<h2 className="text-lg font-semibold mb-4">{title}</h2>

				{/* Options */}
				<div className="flex flex-col gap-3 mb-6">
					<CustomerMultiSelect
						options={customer}
						value={selectedUser}
						onChange={setSelectedUser}
					/>
				{options.map((option) => {
					const isChecked = value.includes(option);
					return (
						<div
							key={option}
							className="flex items-center justify-between bg-gray-800 rounded px-4 py-2 cursor-pointer hover:bg-gray-700 transition"
							onClick={() => toggleOption(option)}
						>
							<span>{option}</span>
							<div
								className={`w-5 h-5 border-2 rounded-sm flex items-center justify-center ${
									isChecked
									? "border-green-500 bg-green-500"
									: "border-gray-400"
								}`}
							>
								{isChecked && (
									<svg
										xmlns="http://www.w3.org/2000/svg"
										className="h-3 w-3 text-black"
										viewBox="0 0 20 20"
										fill="currentColor"
									>
										<path
											fillRule="evenodd"
											d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 10-1.414 1.414l4 4a1 1 0 001.414 0l8-8a1 1 0 000-1.414z"
											clipRule="evenodd"
										/>
									</svg>
								)}
							</div>
						</div>
					);
				})}
				</div>

				{/* Action Buttons */}
				<div className="flex justify-between gap-3">
				<button
					onClick={()=>{onClose(); onChange([]); setSelectedUser([]);}}
					className="flex-1 bg-red-500 hover:bg-red-600 text-white py-2 rounded"
				>
					Cancel
				</button>
				<button
					onClick={handleConfirm}
					disabled={loading}
					className="flex-1 bg-yellow-500 hover:bg-yellow-600 text-black py-2 rounded font-medium"
				>
					{loading ? "Sending..." : "Confirm"}
				</button>
				</div>
			</div>
		</div>
	);
};

export default AddCustomer;
